import { render, staticRenderFns } from "./LayoutContentCenturion.vue?vue&type=template&id=25c4197e&scoped=true&"
import script from "./LayoutContentCenturion.vue?vue&type=script&lang=js&"
export * from "./LayoutContentCenturion.vue?vue&type=script&lang=js&"
import style0 from "./LayoutContentCenturion.vue?vue&type=style&index=0&id=25c4197e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c4197e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VCardText,VDialog,VDivider,VIcon,VImg})
